import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useState } from "react";
import CustomButton from "../CustomButton/CustomButton";
import { useNegotiationsStore } from "../../../stores/negotiationsStore";

interface CreateNegotiationModalProps {
	visible: boolean;
	onHide: () => void;
	onSuccess?: () => void;
}

const CreateNegotiationModal: React.FC<CreateNegotiationModalProps> = ({
	visible,
	onHide,
	onSuccess,
}) => {
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);

	const { createNegotiation } = useNegotiationsStore();

	const handleSubmit = async () => {
		if (!name.trim()) return;

		setIsSubmitting(true);
		try {
			const result = await createNegotiation(
				name.trim(),
				description.trim() || undefined
			);
			if (result) {
				setName("");
				setDescription("");
				onHide();
				onSuccess?.();
			}
		} catch (error) {
			console.error("Error creating negotiation:", error);
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleClose = () => {
		if (!isSubmitting) {
			setName("");
			setDescription("");
			onHide();
		}
	};

	const footer = (
		<div className="flex justify-end gap-2">
			<CustomButton
				label="Cancel"
				variant="outlined"
				iconsOnly={false}
				onClick={handleClose}
				disabled={isSubmitting}
			/>
			<CustomButton
				label={isSubmitting ? "Creating..." : "Create"}
				variant="primary"
				iconsOnly={false}
				onClick={handleSubmit}
				disabled={!name.trim() || isSubmitting}
			/>
		</div>
	);

	return (
		<Dialog
			header="Create New Negotiation"
			visible={visible}
			style={{ width: "450px" }}
			footer={footer}
			onHide={handleClose}
			closable={!isSubmitting}
			modal
		>
			<div className="flex flex-col gap-4 w-full">
				<div className="flex flex-col gap-2">
					<label htmlFor="negotiation-name" className="font-medium">
						Name <span className="text-red-500">*</span>
					</label>
					<InputText
						id="negotiation-name"
						value={name}
						onChange={(e) => setName(e.target.value)}
						placeholder="Enter negotiation name"
						disabled={isSubmitting}
						className="w-full"
					/>
				</div>

				<div className="flex flex-col gap-2">
					<label
						htmlFor="negotiation-description"
						className="font-medium"
					>
						Description
					</label>
					<InputTextarea
						id="negotiation-description"
						value={description}
						onChange={(e) => setDescription(e.target.value)}
						placeholder="Enter negotiation description (optional)"
						disabled={isSubmitting}
						rows={3}
						className="w-full"
					/>
				</div>
			</div>
		</Dialog>
	);
};

export default CreateNegotiationModal;
